export const EVENT_TYPE = {
  MATCH: 'match',
  OUTRIGHT: 'outright',
} as const;

export const CONDITION_PRODUCT_TYPE = {
  PRE_MATCH: 'PRE_MATCH',
  IN_PLAY: 'IN_PLAY',
  BONUS: 'BONUS',
  MIXED: 'MIXED',
} as const;

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export const TICKET_AUTH_MODE = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
} as const;

export const APPROVAL_MODE = {
  AUTO_REJECT: 'AUTO_REJECT',
  MANUAL_VERIFY: 'MANUAL_VERIFY',
  VERIFY_ALL: 'VERIFY_ALL',
  NONE: 'NONE',
} as const;

export const WALLET_TYPE = {
  MAIN: 'main',
  BONUS: 'bonus',
} as const;

export const CREDIT_ACTION_TYPE = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
} as const;

export const WALLET_TRANSACTION_TYPE = {
  ...CREDIT_ACTION_TYPE,
  BONUS: 'bonus',
  OTHER: 'other',
  TRANSFER: 'transfer',
  WON_BET: 'won_bet',
  PLACE_BET: 'place_bet',
  CASH_OUT: 'cash_out',
  WON_TO_LOST_BET: 'won_to_lost_bet',
} as const;

export const WALLET_TRANSACTION_SOURCE = {
  SPORTSBOOK: 'sportsbook',
  CASINO: 'casino',
} as const;

export const BETTING_SLIP_FROM = {
  PRE_MATCH: 'Pre-match',
  IN_PLAY: 'In-play',
  MIX: 'Mix',
} as const;

export const BETTING_SLIP_STATUS = {
  OPEN: 'open',
  VOID: 'void',
  WON: 'won',
  LOST: 'lost',
  CASHOUT: 'cashout',
} as const;

export const BETTING_SLIP_TYPE = {
  SINGLE: 'Single',
  MULTIPLE: 'Multiple',
  SYSTEM: 'System',
} as const;

export const BETTING_SLIP_ACCEPT_STATUS = {
  ACCEPTED: 'accepted',
  PENDING: 'pending',
  REJECTED: 'rejected',
  ADMIN_CANCELLED: 'admin_cancelled',
} as const;

export const PRODUCT_TYPE = {
  PRE_MATCH: 'pre-match',
  IN_PLAY: 'in-play',
} as const;

export const MARKET_TYPE_GROUP_DISPLAY_TYPE = {
  MATCH: 'match',
  TOURNAMENT: 'tournament',
} as const;

export const MARKET_GROUP_TYPE = {
  NORMAL: 'NORMAL',
  MIXED: 'MIXED',
} as const;

export const ICON_GROUP = {
  SPORTS: 'sports',
  JACKPOT: 'jackpot',
  CASINO_JACKPOT: 'casino-jackpot',
} as const;

export const FEED_SOURCE = {
  FEED_THE_BET: 'FTB',
  ODDS_MATRIX: 'ODDS_MATRIX_FEED',
} as const;

export const SPORT_ICON_VARIANT = {
  COLOR: 'color',
  FLAT: 'flat',
  MULTICOLOR: 'multicolor',
  NEOBET: 'neobet',
  SIMPLE: 'simple',
} as const;

export const COMPETITIONS_FLAG_VARIANT = {
  DEFAULT: 'default',
  V1: 'v1',
} as const;

export const MARKET_TYPE_DISPLAY_TYPE = {
  MULTIPLE: 'MULTIPLE',
  TEAM: 'TEAM',
  SINGLE: 'SINGLE',
  GROUPED: 'GROUPED',
} as const;

export const BONUS_CAMPAIGN_TYPE = {
  CASHBACK: 'CASHBACK',
  WELCOME_BONUS: 'WELCOME_BONUS',
  NUM_OF_SELECTIONS: 'NUM_OF_SELECTIONS',
} as const;

export const CAMPAIGN_REWARD_TYPE = {
  BONUS_CREDITS: 'BONUS_CREDITS',
  REAL_MONEY: 'REAL_MONEY',
  FREE_SPINS: 'FREE_SPINS',
} as const;

export const WELCOME_BONUS_ELIGIBILITY = {
  FIRST_TIME_DEPOSIT: 'FIRST_TIME_DEPOSIT',
} as const;

export const WELCOME_BONUS_TYPE = {
  UNLOCK: 'UNLOCK',
  UPFRONT: 'UPFRONT',
} as const;

export const WELCOME_BONUS_STATUS = {
  READY: 'READY',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
} as const;

export const WELCOME_BONUS_SCOPE = {
  GLOBAL: 'GLOBAL',
  SPECIAL: 'SPECIAL',
} as const;

export const WELCOME_BONUS_WAGERING_MODE = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  MULTIPLIER: 'MULTIPLIER',
} as const;

export const WELCOME_BONUS_GAME_WEIGHTING_CATEGORY = {
  SLOTS: 'SLOTS',
  ROULETTE: 'ROULETTE',
  BLACKJACK: 'BLACKJACK',
  LIVE_CASINO: 'LIVE_CASINO',
} as const;

export const MARKET_TYPE_USED_FOR = {
  PRE_MATCH: 'pre_match',
  IN_PLAY: 'in_play',
} as const;

export const PAYMENT_GATEWAY = {
  CRYPTO: 'CRYPTO',
  PAY_2_LOCAL: 'PAY_2_LOCAL',
  KAPOPAY: 'KAPOPAY',
} as const;

export const PAYMENT_TYPE = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
} as const;

export const WITHDRAWAL_STATUS = {
  REQUESTED: 'requested',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export const APPROVAL_ACTION = {
  APPROVE: 'approve',
  REJECT: 'reject',
  COMPLETE: 'complete',
} as const;

export const PAYMENT_LIMIT_NAME = {
  MIN_AMOUNT_PER_TRANSACTION: 'minAmountPerTransaction',
  MAX_AMOUNT_PER_TRANSACTION: 'maxAmountPerTransaction',
  MAX_DAILY_AMOUNT: 'maxDailyAmount',
  MAX_WEEKLY_AMOUNT: 'maxWeeklyAmount',
  MAX_MONTHLY_AMOUNT: 'maxMonthlyAmount',
  MAX_DAILY_COUNT: 'maxDailyCount',
  MAX_WEEKLY_COUNT: 'maxWeeklyCount',
  MAX_MONTHLY_COUNT: 'maxMonthlyCount',
  VERIFY_ALL: 'verifyAll',
  MASTER_WALLET_LOW_BALANCE: 'masterWalletLowBalance',
} as const;

export const BETTING_ACTIVITY = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export const VALIDITY_PERIOD = {
  CUSTOM: 'CUSTOM',
  ONGOING: 'ONGOING',
} as const;

export const AFFILIATE_CAMPAIGN_STATUS = {
  READY: 'READY',
  IN_PROGRESS: 'IN_PROGRESS',
  PAUSED: 'PAUSED',
  FINISHED: 'FINISHED',
} as const;

export const AFFILIATE_CAMPAIGN_TYPE = {
  BANNER: 'BANNER',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  EMAIL: 'EMAIL',
  INFLUENCER: 'INFLUENCER',
  OTHER: 'OTHER',
} as const;

export const AFFILIATE_CAMPAIGN_PRODUCT = {
  SPORTSBOOK: 'SPORTSBOOK',
  CASINO: 'CASINO',
  ALL: 'ALL',
} as const;

export const AFFILIATE_BONUS_REWARD_TYPE = {
  BONUS_CREDITS: 'BONUS_CREDITS',
  REAL_MONEY: 'REAL_MONEY',
} as const;

export const AFFILIATE_BONUS_CATEGORY = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
} as const;

export const ODDS_FORMAT = {
  DECIMAL: 'DECIMAL',
  FRACTIONAL: 'FRACTIONAL',
  AMERICAN: 'AMERICAN',
} as const;

export const REOFFER_ODDS_DISPLAY = {
  ALL: 'ALL',
  NEW: 'NEW',
} as const;
export const TEAM_ASSETS_VARIANT = {
  NONE: 'none',
  LOGO: 'logo',
  JERSEY: 'jersey',
} as const;
